module.exports = __webpack_public_path__ + "img/portal_1.911dad9c.gif";